import { LlmHistory, useLlm } from '@websolutespa/bom-mixer-llm';
import { useMemo } from 'react';
import { HistoryGroup, IHistoryGroup } from './history-group';
import style from './history.module.scss';

export const History: React.FC = () => {
  const history = useLlm(state => state.history);
  // console.log(history);
  const groups = useMemo(() => {
    return groupHistory(history);
  }, [history]);
  return (
    <div className={style.listing}>
      <div className={style.title}>Chat history</div>
      {groups.length > 0 ? (
        groups.map((group) => (
          <HistoryGroup key={group.id} group={group} />
        ))
      ) : (
        <div className={style.empty}>No message here yet</div>
      )}
    </div>
  );
};

function groupHistory(history:LlmHistory[]) {
  const now = new Date();
  const ty = now.getFullYear();
  const tm = now.getMonth();
  const td = now.getDate();
  const todayGroup: IHistoryGroup = { id: 'today', title: 'Today', items: [] };
  const olderGroup: IHistoryGroup = { id: 'older', title: 'Older', items: [] };
  const groups: IHistoryGroup[] = [
    todayGroup,
    olderGroup,
  ];
  history.forEach(item => {
    if (item.createdAt && item.user) {
      const createdAt = new Date(item.createdAt);
      const y = createdAt.getFullYear();
      const m = createdAt.getMonth();
      const d = createdAt.getDate();
      if (ty === y && tm === m && td === d) {
        todayGroup.items.push(item);
      } else {
        olderGroup.items.push(item);
      }
    }
  });
  return groups.filter(x => x.items.length > 0);
}

function groupHistoryByWeekMonth(history:LlmHistory[]) {
  const now = new Date();
  const ty = now.getFullYear();
  const tm = now.getMonth();
  const td = now.getDate();
  const today = new Date(ty, tm, td, 0, 0, 0, 0);
  const todayGroup: IHistoryGroup = { id: 'today', title: 'Today', items: [] };
  const lastWeekGroup: IHistoryGroup = { id: 'week', title: 'Last week', items: [] };
  const lastMonthGroup: IHistoryGroup = { id: 'month', title: 'Last month', items: [] };
  const groups: IHistoryGroup[] = [
    todayGroup,
    lastWeekGroup,
    lastMonthGroup,
  ];
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
  });
  history.forEach(item => {
    if (item.createdAt && item.user) {
      const createdAt = new Date(item.createdAt);
      const y = createdAt.getFullYear();
      const m = createdAt.getMonth();
      const d = createdAt.getDate();
      const date = new Date(y, m, d, 0, 0, 0, 0);
      const diffTime = Math.abs(date.getTime() - today.getTime());
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (ty === y && tm === m && td === d) {
        todayGroup.items.push(item);
      } else if (diffDays <= 7) {
        lastWeekGroup.items.push(item);
      } else if (diffDays <= 30) {
        lastMonthGroup.items.push(item);
      } else {
        const groupId = `group-${y}-${m}`;
        let group = groups.find(x => x.id === groupId);
        if (!group) {
          group = { id: groupId, title: dateFormatter.format(date), items: [] };
          groups.push(group);
        }
        group.items.push(item);
      }
    }
  });
  return groups.filter(x => x.items.length > 0);
}
